// extracted by css-extract-rspack-plugin
export default {"StepDescription":"XvJC7"};